import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDContentContainer, FDEmphasisSurface, FDFacetLogo, FDIcon, FDStack, useFDBodyColor,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import { LottieLoadingLayout } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  EmailVerificationSentLottie,
} from './EmailVerificationSentLottie';


const useStyles = buildUseStyles('EmailVerificationSentLayout', (theme) => ({
  root: {
    height: '100dvh',
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'flex-end',
    animation: '$fade-in 1s',

    '& a': {
      color: theme.palette.primary.contrastText,
      textDecoration: 'underline',
    },
  },
  logo: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10,
    padding: '32px 0',
  },
  checkEmailBox: {
    backgroundColor: 'rgb(0, 62, 84, 0.5)',
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
  },
  lottieContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    maxHeight: '50dvh',
    maxWidth: '500px',
  },
  textContainer: {
    flex: 1,
    paddingBottom: theme.spacing(2),
  },
  subscript: {
    paddingTop: theme.spacing(3),
    textAlign: 'center',
    maxWidth: '700px',
  },
  '@keyframes fade-in': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
}));

export const EmailVerificationSentLayout = ({ resource }) => {
  const classes = useStyles();
  const isMobile = useMobileLayout();

  useFDBodyColor('calm');

  return (
    <LottieLoadingLayout>
      <div className={classes.root} {...dataAttrs('emailVerificationSent step')}>
        <FDContentContainer maxWidth="sm">
          <div className={classes.logo}>
            <FDFacetLogo color={'secondary'} />
          </div>
          <FDStack direction={'column'} justifyContent="center" alignItems={'center'} spacing={4} maxHeight={'100dvh'}>
            <div className={classes.lottieContainer}>
              {resource.withRelationship(fr.relationships.lottie.name,
                (rel) => (<EmailVerificationSentLottie relationship={rel} />),
                () => null)}
            </div>
            <div className={classes.textContainer}>
              <FDStack direction="column" justifyContent="center" alignItems={'center'} spacing={isMobile ? 3 : 4}>
                <MetaControlField attr="emailVerificationStepTitle" />
                <MetaControlField attr="subtitle" />
                <FDEmphasisSurface padding={2}>
                  <FDStack direction={'column'} spacing={2}>
                    <FDStack spacing={1} alignItems={'center'}>
                      <FDIcon icon={resource.attr('icon')} color={'info'} />
                      <MetaControlField attr={'subscriptHeader'} />
                    </FDStack>
                    <MetaControlField attr={'subscript'} />
                  </FDStack>
                </FDEmphasisSurface>
              </FDStack>
            </div>
          </FDStack>
        </FDContentContainer>
      </div>
    </LottieLoadingLayout>
  );
};
